import React from 'react';
import type { ViewImages, ViewKey } from './carWizardTypes';
import type { Layer } from './LayeredPreview';

interface Props {
  showSummary: boolean;
  viewLoading: boolean;
  selectedView: ViewKey;
  setSelectedView: (view: ViewKey) => void;
  setViewLoading: (loading: boolean) => void;
  currentImageSource: { images: ViewImages } | null;
  getThumbnailForView: (viewKey: ViewKey) => Layer[];
  viewKeys: readonly ViewKey[];
}

const ViewSelector: React.FC<Props> = ({
  showSummary,
  viewLoading,
  selectedView,
  setSelectedView,
  setViewLoading,
  currentImageSource,
  getThumbnailForView,
  viewKeys,
}) => {
  return (
    <div className="mb-4">
      <div className="flex gap-2 overflow-x-auto overflow-y-hidden custom-scrollbar">
        {viewKeys.map((viewKey, idx) => {
          const viewLayers = getThumbnailForView(viewKey);
          const hasCurrentView =
            !!currentImageSource?.images?.[viewKey] &&
            currentImageSource.images[viewKey]!.startsWith('http');

          return (
            <button
              key={viewKey}
              onClick={() => {
                setViewLoading(true);
                setSelectedView(viewKey);
                setTimeout(() => setViewLoading(false), 0);
              }}
              className={`rounded-lg p-2 bg-gray-100 cursor-pointer transition-all duration-200 hover:shadow-md flex-shrink-0 relative border-0 outline-none ${
                selectedView === viewKey ? 'shadow-md bg-gray-200 scale-[1.02]' : 'shadow-sm'
              }`}
              disabled={viewLoading}
            >
              <div className="relative h-14 w-24">
                {viewLayers.length > 0 ? (
                  viewLayers.map((layer, layerIdx) => (
                    <img
                      key={`${layer.type}-${layerIdx}`}
                      src={layer.url}
                      alt={`View ${idx + 1} - Layer ${layerIdx}`}
                      className={`h-14 w-24 object-cover ${layerIdx === 0 ? 'relative' : 'absolute inset-0'}`}
                      style={{ zIndex: layer.zIndex }}
                    />
                  ))
                ) : (
                  <div className="h-14 w-24 bg-gray-200" />
                )}

                {!hasCurrentView && !showSummary && (
                  <div className="absolute inset-0 bg-white/60" />
                )}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ViewSelector;
